import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=71df7eb6&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "./SideBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SideBar.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/SideBar.vue
// module id = 1646
// module chunks = 1